import { restoreDraftOrder, getActiveOrderByUid } from "./slices/cartSlice";

export function hydrateCart(store) {
  // 1. Load draft order
  const storeId = store?.getState()?.auth?.user?.storeId;
  const draft = localStorage.getItem("draft_order");
  if (draft) {
    try {
      const parsed = JSON.parse(draft);
      store.dispatch(restoreDraftOrder(parsed));
    } catch (_) {}
  }

  // 2. Load active order uid (table order)
  let activeOrderUid = localStorage.getItem("active_order_uid");

  if (
    !activeOrderUid ||
    activeOrderUid === "undefined" ||
    activeOrderUid === "null"
  ) {
    activeOrderUid = null;
  }
  if (activeOrderUid) {
    store.dispatch(
      getActiveOrderByUid({
        storeId,
        orderUid: activeOrderUid,
      })
    );
  }
}
